
<div>
    <div :class="statusClass">

    </div>
    <div v-if="row.status === 'CRITICAL'" class="red--text mt-2 ml-1">
        <i :class="criticalIcon"></i>
    </div>
</div>
